import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { name, description, startDate, endDate, progress, Status, projectId },
} = checkout;

const validations = [
  Yup.object().shape({
    [name.name]: Yup.string().required(name.errorMsg),
    // [description.name]: Yup.string().required(description.errorMsg),
    [startDate.name]: Yup.date().required(startDate.errorMsg),
    [endDate.name]: Yup.date().required(endDate.errorMsg),
    [progress.name]: Yup.number().required(progress.errorMsg).min(0).max(100),
    [Status.name]: Yup.number().required(Status.errorMsg).min(0),
    [projectId.name]: Yup.string().required(projectId.errorMsg).min(1),
  }),
];

export default validations;
